import * as React from 'react';
import type { SVGProps } from 'react';
const SvgDownloadArrow = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    fill="none"
    {...props}
  >
    <path
      d="M12 5.25V14.25M8 10.25L12 14.25L16 10.25M7 18.75H17"
      stroke="currentColor"
      strokeWidth={1.8}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export default SvgDownloadArrow;
